export const MAX_ERROR_LENGTH = 1000;
export const endpoints = {
    request: 'r',
    impression: 'i',
    failure: 'f',
    end: 'end',
};
export const providerToAdNetworkMap = {
    google: 'dfp',
    adswizz: 'adswizz',
};
export const ERROR_CODES = {
    VAST_LOAD_TIMEOUT: 301,
    VAST_NO_ADS_AFTER_WRAPPER: 303,
    VAST_EMPTY_RESPONSE: 1009,
};
